import React from 'react';
import { AddNoteRequest } from '../../services/api';
import { X } from 'lucide-react';
import './CaseModals.css';

interface AddNoteModalProps {
  isOpen: boolean;
  noteData: AddNoteRequest;
  setNoteData: (data: AddNoteRequest) => void;
  isAdding: boolean;
  onClose: () => void;
  onAdd: () => void;
}

const AddNoteModal: React.FC<AddNoteModalProps> = ({
  isOpen,
  noteData,
  setNoteData,
  isAdding,
  onClose,
  onAdd,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="add-note-modal">
        <div className="modal-header">
          <h2>Add Note</h2>
          <button onClick={onClose} className="close-modal-btn">
            <X size={24} />
          </button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label htmlFor="note-type">Note Type</label>
            <select
              id="note-type"
              value={noteData.typeTag || 'Note'}
              onChange={(e) => setNoteData({ ...noteData, typeTag: e.target.value })}
              className="form-select"
            >
              <option value="Note">General Note</option>
              <option value="Meeting">Meeting</option>
              <option value="Phone Call">Phone Call</option>
              <option value="Email">Email</option>
              <option value="Task">Task</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="note-body">Note Content</label>
            <textarea
              id="note-body"
              value={noteData.body}
              onChange={(e) => setNoteData({ ...noteData, body: e.target.value })}
              placeholder="Enter note content..."
              className="form-textarea"
              rows={8}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button onClick={onAdd} disabled={!noteData.body || isAdding} className="add-btn">
            {isAdding ? 'Adding...' : 'Add Note'}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddNoteModal;

